import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';

export default class Bathroom extends Model {
  static entity = 'bathrooms';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(null),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      residences: this.hasMany(Residence, 'bathroom_id'),
    }
  }

  static transformer(data) {
    const bathrooms = [];
    data.data.forEach(item => {
      const bathroom = {};
      bathroom.id = item.id;
      bathroom.name = item.name;
      bathroom.slug = item.slug;
      bathroom.count = item.count;
      bathroom.description = item.description;
      bathrooms.push(bathroom);
    })
    return bathrooms;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    let url = '/wp-json/wp/v2/bathrooms';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}